import { render } from "./DatadogDowntime.vue?vue&type=template&id=b81fd99c&scoped=true"
import script from "./DatadogDowntime.vue?vue&type=script&lang=js"
export * from "./DatadogDowntime.vue?vue&type=script&lang=js"

import "./DatadogDowntime.vue?vue&type=style&index=0&id=b81fd99c&lang=css&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b81fd99c"]])

export default __exports__